export default __webpack_public_path__ + "static/media/bathroom-mid.d691cc21.mp4";